import { GET, POST } from "../../../module/services/fetch";
import { map } from "rxjs/operators";
import { OtpOperationType } from "../../../module/constants";
import { ContactsType } from "../../../components/Modals/ContactsModal/module/constants";
import {
  SecurityQuestionBody,
  UigpOtpBody,
} from "../../../common/TwoFactorAuth/module/constants";

export const fetchUserAccountRequest = () =>
  GET(`user/accounts`).pipe(map((response: any) => response));

export const forcedResetService = (body: {
  accountId: string;
  identitySystemId: string;
  password: string;
  otp: string;
}) => {
  return POST(`user/resetPwd`, body).pipe(map((response: any) => response));
};

export const verifyArcotResetService = (body: {
  accountId: string;
  identitySystemId: string;
  password: string;
  otp: string;
}) => POST(`user/resetPassword`, body).pipe(map((response: any) => response));

export const fetchGetSecurityQuestionsReset = () =>
  GET(`authentication/question?operation=RESET_PWD`).pipe(
    map((response: any) => response)
  );

export const generateUigpOTP = (body: {
  operation: OtpOperationType;
  method: ContactsType;
}) => {
  const { method, operation } = body;
  return GET(
    `authentication/otp?operation=${operation}&deliveryMethod=${method}`
  ).pipe(map((res: any) => res));
};

export const verifyUigpOTP = (body: UigpOtpBody) => {
  return POST(`authentication/validate-reset-pwd`, body).pipe(
    map((res: any) => res)
  );
};

export const verifySecurityQuestionsResetService = (
  body: SecurityQuestionBody
) => {
  return POST(`authentication/question/verify/reset-pwd`, body).pipe(
    map((response: any) => response)
  );
};
